import { EntityPanelPersonsForm, EntityPanelVehiclesForm } from './types';

export const stubEntityFormFields: EntityPanelPersonsForm & EntityPanelVehiclesForm = {
    mergedInvolvedPersons: [],
    mergedReportingParties: [],
    reportingParties: [],
    involvedVehicles: [],
    involvedPersons: [],
    vehicles: [],
    mergedVehicles: [],
    towVehicles: [],
    mergedTowVehicles: [],
    location: null,
};
